import superAdminApi from "./superAdminApi";

/**
 * Upload a single image for CMS marketing pages (About / Contact).
 * Returns the stored media path (e.g. /media/...).
 * Uses category `auth` (allowed by the upload validator).
 */
export async function uploadCmsPageImage(file, { fileType = "cms_page_image" } = {}) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("category", "auth");
  formData.append("companyName", "CMS_Pages");
  formData.append("fileType", fileType);

  const res = await superAdminApi.post("/upload/single", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const imagePath = res?.data?.data?.accessPath || res?.data?.data?.filePath || null;
  if (!imagePath) {
    throw new Error("Image upload failed.");
  }
  return imagePath;
}
